import { StyleSheet } from 'react-native'

const useStyles = (theme) => StyleSheet.create({
  card: {
    paddingHorizontal: 10,
    marginBottom: 10,
    flex: 1
  },
  cardContent: {
    backgroundColor: theme.CARD_BACKGROUND
  },
  details: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  text: {
    marginLeft: 10
  },
  tractorsNumber: {
    marginLeft: 10
  },
  tractors: {
    flex: 2,
    flexDirection: 'row',
    alignItems: 'center'
  },
  equipment: {
    flex: 2,
    flexDirection: 'row',
    alignItems: 'center',
    marginHorizontal: 15
  },
  teams: {
    flex: 1
  },
  actions: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end'
  }
})

export default useStyles
